import React from "react";
import { Route, Routes } from "react-router-dom";
import GroupTable from "../Master/Group/GroupTable";
import { SearchLedgerByGroupsTypes } from "../../Services/LedgerService";
import LedgerTable from "../Master/Ledger/LedgerTable";
import ResourceNotFound from "../../Common/ResourceNotFound";
import {
  findUserOnlyOnePremission,
  findUserPremission,
} from "../Users/Roles/UserSecurityFind";
import { useUser } from "../../../Context/UserContext";
import { useClient } from "../../Context/ClientContext";
import { SettingsSections } from "../../Services/SettingService";
import { IPermissionActionType } from "../Users/Roles/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../Context/RoleContext";
import CostCenters from "./CostCenters";
import SalesInvoiceAndPurchaseBillGraph from "../SalesAndPurchase/InvoiceAndPurchaseBill/Table/SalesInvoiceAndPurchaseBillGraph";
import { Voucher_Type } from "../../Services/VoucherServices";

const ExpensesIncomeNestedRoute: React.FC = () => {
  const { clientSpecificRole } = useUser();
  const { currentClient } = useClient();

  return (
    <>
      <Routes>
        <Route>
          <Route
            path="/expenses"
            element={
              findUserPremission(
                ["Voucher.Expenses.14.View"],
                clientSpecificRole(),
                currentClient?.id!,
                [SettingsSections.Expenses],
                {
                  actionType: IPermissionActionType.View,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                // <Expenses />
                <SalesInvoiceAndPurchaseBillGraph
                  voucherType={Voucher_Type.Expenses}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />

          <Route
            path="/income"
            element={
              findUserPremission(
                ["Voucher.Income.15.View"],
                clientSpecificRole(),
                currentClient?.id!,
                [SettingsSections.Income],
                {
                  actionType: IPermissionActionType.View,
                  dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                }
              ) ? (
                // <Expenses />

                <SalesInvoiceAndPurchaseBillGraph
                  voucherType={Voucher_Type.Income}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />

          <Route
            path="/expensesLedger"
            element={
              findUserOnlyOnePremission(
                "Master.Ledger.Expenses.View",
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <LedgerTable
                  showName="Expense"
                  ledgerByGroupsType={SearchLedgerByGroupsTypes.AllExpenses}
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path="/incomeLedger"
            element={
              findUserOnlyOnePremission(
                "Master.Ledger.Income.View",
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <LedgerTable
                  showName="Income"
                  ledgerByGroupsType={
                    SearchLedgerByGroupsTypes.IndirectIncomeOnly
                  }
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path="/expensesGroup"
            element={
              findUserOnlyOnePremission(
                "Master.Group.Expenses.View",
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <GroupTable
                  showName="Expenses Group"
                  searchLedgerByGroupsTypes={
                    SearchLedgerByGroupsTypes.AllExpenses
                  }
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route
            path="/incomeGroup"
            element={
              findUserOnlyOnePremission(
                "Master.Group.Income.View",
                clientSpecificRole(),
                currentClient?.id!
              ) ? (
                <GroupTable
                  showName="Income Group"
                  searchLedgerByGroupsTypes={
                    SearchLedgerByGroupsTypes.IndirectIncomeOnly
                  }
                />
              ) : (
                <ResourceNotFound pageHeight="100%" />
              )
            }
          />
          <Route path="/costCentres" element={<CostCenters />} />
        </Route>
      </Routes>
    </>
  );
};
export default ExpensesIncomeNestedRoute;
